<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";
import HedefKartiDetay from "./hedefkartidetay.vue"

export default {
    mixins: [Api, Sabit],
    props: ["TabloId", "DonemId","AltDonemId","Sorgulama"],
    components: {
        Loader,
        HedefKartiDetay
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            Data: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
        TabloId() {
            this.Get();
        },
    },
    methods: {
        Get() {

            let Filter = "&DonemId=" + this.AltDonemId + "&UstDonemId="+ this.DonemId + "&Tabloid=" + this.TabloId;
            this.ActionsFilterGet({ Service: "StrRaporlama/GetHedefKarti", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data;
            });
        },
        DetayData(Data){
            return this.groupBy(Data.Detay, 'Donem')
        },
        DetayData2(Data){
            return this.groupBy(Data.Detay, 'Gostergesi')
        },
        groupBy(array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },
        Fark(Data){
            var Fark = 0;
            if(Data){
              Fark = Data.Universitehedefi - Data.Birimbazlihedeftoplam  
            }
            return Fark;
        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.veriGiris;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
    },

    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader>
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'HedefKartı',
                        'HedefKartı',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                        <tr>
                            <td colspan="10" class="h5"
                                style="text-align: center; font-family: Arial; display: block;">
                                Hedef Kartı <br>              
                            </td>
                        </tr>
                    </table>
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive" v-for="(Data,index) in this.TableData" :key="index">
                                    <div class="col-12"> 
                                        <HedefKartiDetay :Data="Data" v-if="Data.Detay.length > 0" />
                                    </div>
                                    
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                
            </div>
        </div>
    </Loader>
</template>
<style>
td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
